import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 瞬时跳转到指定模块，使模块顶部与屏幕顶部对齐（不使用平滑滚动）。
 */
export function guaziScrollToSection(id: string) {
  if (typeof document === 'undefined' || !id) return;
  const el = document.getElementById(id);
  if (!el) return;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  const top = el.getBoundingClientRect().top + scrollTop;
  if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, top);
  } else {
    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
  }
}

/**
 * 生成模块锚点链接。
 * - 在首页使用 `#id`（原生锚点跳转，不依赖 history.pushState）；
 * - 在其它页面使用 `/#id`（整页真实跳转，兼容百度APP等内置浏览器）。
 *
 * 不使用 react-router 的 navigate / pushState，避免被内置浏览器容器静默拦截。
 */
export function useGuaziSectionHref() {
  const location = useLocation();
  return useCallback(
    (id: string) => (location.pathname === '/' ? `#${id}` : `/#${id}`),
    [location.pathname],
  );
}